import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstitutionEdit from '@/ui/pages/InstitutionEdit/InstitutionEdit';

export const Route = createFileRoute('/_dashboard/institutions/new')({
  beforeLoad: requireRoute('/institutions/new'),
  component: InstitutionEdit,
});
